import {
  SubscriptionCouponResource,
  subscriptionCouponResourceSchema,
} from "@client/resources/SubscriptionCouponResource";
import { APIMethods, ApiResponse } from "@typeDefinitions";
import { fetchData } from "@utils/api";
import { logFetchValidateError } from "@utils/validate";
import { array, object } from "yup";

export type FetchSubscriptionCouponsResponse = ApiResponse<
  SubscriptionCouponResource[]
>;

const fetchSubscriptionCouponsResponseSchema = object({
  data: array().of(subscriptionCouponResourceSchema).required(),
});

export const fetchSubscriptionCoupons =
  async (): Promise<FetchSubscriptionCouponsResponse> => {
    const response = await fetchData(
      "/dietitian/subscription/coupons",
      APIMethods.GET,
    );

    return await fetchSubscriptionCouponsResponseSchema
      .validate(response)
      .catch(logFetchValidateError("/dietitian/subscription/coupons"));
  };
